import ListPaginator from './ListPaginator';

export default ListPaginator;
